module.exports = __webpack_public_path__ + "img/draw_empty.6dac17fd.png";